import { PureAbility, AbilityBuilder } from '@casl/ability';

// Below function is to check the user has access for the operations.

export function defineAbilities(privileges, selectedDataModelID) {
    const { can, cannot, build } = new AbilityBuilder(PureAbility);

    const modelPermissions = privileges;

    // console.log("Ability check ==>> ", modelPermissions, selectedDataModelID, privileges)

    if (modelPermissions) {
        if (modelPermissions.ALL) {
            // console.log("ALL ========>>> ", modelPermissions.ALL)
            // Grant access to all actions if ALL is true
            can('manage', 'Resource'); // 'manage' is a special keyword in CASL that allows all actions
        } else {
            // Otherwise, grant access to only specified actions
            Object.keys(modelPermissions).forEach(action => {
                if (modelPermissions[action]) {
                    can(action.toLowerCase(), 'Resource');
                }
            });
        }
    } else {
        cannot('manage', 'all'); // If no permissions exist, restrict everything
    }

    return build();
}

// export const ability = new Ability(); // Default empty ability

// Below function is to check the user has access or not, from the ability object(Previlages).
export const fetchPrivilegeSupport = (props, chartData) => {
    // TODO: Need to pass only needed Props of redux formData, appid, selectedDataModel
    if (!props?.privilegesSupport) {
        return { privilegeData: { ALL: true }, ability: defineAbilities({ ALL: true }, chartData?.selectedDataModel) };
    } else {
        if (!chartData?.selectedDataModel) {
            console.log("No DATA MODEL FOUND FOR THE PAGE");
            return { privilegeData: { ALL: true }, ability: defineAbilities({ ALL: true }, chartData?.selectedDataModel) };
        }
        else if (
            props.formData?.document &&
            props.formData.document[`${props.match.params.appid}_memberprivileges`] &&
            props.formData.document[`${props.match.params.appid}_memberprivileges`].supportPrivileges
        ) {
            const selectedPrivileges = props.formData.document[`${props.match.params.appid}_memberprivileges`]?.privileges[chartData?.selectedDataModel];
            if (selectedPrivileges) {
                console.log("Privileges found:", selectedPrivileges);
                return { privilegeData: selectedPrivileges, ability: defineAbilities(selectedPrivileges, chartData?.selectedDataModel) };
            }
            else {
                console.log("No privileges found for the given ID.");
                return { privilegeData: {}, ability: {} };
            }
        }
    }
};

// Below Function is to validate the error is from RBAC or not.

export const validateAccessControlResponse = (data, setIsAccessControl) => {
    let output = {
        error: false,
        message: "",
        code: ""
    };

    if (data?.code?.includes("RBAC")) {
        output = {
            error: true,
            message: "User does not have permissions to access the document" || data.message,
            code: data.code || ""
        };
    }

    return setIsAccessControl(output)
}

// To check the multiple actions

export const canAny = (ability, actions, resource) =>
    actions.some(action => ability.can(action, resource));

export const SystemOperations = {
    "CREATE": "create",
    "VIEW": "view",
    "EDIT": "edit",
    "DELETE": "delete",
    "DOWNLOAD": "download",
    "SEARCH": "search",
    "MOVE": "move",
    "CHAT": "chat",
    "ALL": "all"
}

// export const ability = new Ability(); // Default empty ability

export const hasAbility = (ability) => {
    return ability && Object.keys(ability.rules || {}).length > 0;
};


// Below code is to check only View access is there for the user.

const editOps = ['CREATE', 'EDIT', 'DELETE', 'CHAT', 'SEARCH', 'MOVE', 'DOWNLOAD', 'ALL'];

export const isViewOnly = (ability, subject) => {
    if (ability && Object.keys(ability || {}).length > 0) {
        return ability.can(SystemOperations.VIEW, subject) &&
            !editOps.some(op => ability?.can(SystemOperations[op], subject))
    }
}